import { customFetch, customFetchOptions, handleFetchError } from "@refere/ui-utils/ui/utils/fetch";

/**
 * Empacota a chamada para fetch, usando a biblioteca do refere-ui-utils. 
 * - Trata o fetch para ter valores default de método e retorna a response com tratamentos em caso de erro.
 * @param input 
 * @param init 
 * @param options 
 * @returns 
 */
export async function fetchWrapper<T>(
    input: string, 
    init?: RequestInit,
    options?: customFetchOptions) : Promise<T> {

    const _init = {
        method: "GET",
        ...(init ?? { })
    } as RequestInit;

    return handleFetchError(customFetch<T>(input, _init, options))
}